// extracted by mini-css-extract-plugin
export var dropdownIcon = "_lz-6";
export var imgContainer = "_lz-3";
export var menuIcon = "_lz-5";
export var pillWrapper = "_lz-2";
export var pillsContainer = "_lz-1";
export var subscriptionCard = "_lz-0";
export var subscriptionLogo = "_lz-4";